import React from "react";
import { connectRefinementList } from "react-instantsearch-dom";
import { Box, Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
// import { useAnalytics } from "use-analytics";

type RefinementListProps = {
  refine: Function;
  onlyRefined: boolean;
  items: Array<object>;
  heading?: string;
  currentRefinement: string[];
  virtual?: boolean;
  className?: string;
};

const useStyles = makeStyles((theme) => ({
  chip: {
    margin: theme.spacing(1),
    "&:nth-child(1)": {
      marginLeft: 0,
    },
    "&:last-child": {
      marginRight: theme.spacing(4),
    },
  },
  chipUnselected: {
    backgroundColor: theme.palette.common.white,
  },
}));

const RefinementListChips: React.FunctionComponent<any> = (props): JSX.Element | null => {
  const { onlyRefined = true, virtual = false, items, refine, currentRefinement, className }: RefinementListProps = props;
  const classes = useStyles();
  //const analytics = useAnalytics();

  // const handleClick = (event: React.MouseEvent, refineValue: object, label: string) => {
  //   event.preventDefault();
  //   // analytics.track("b filter attribute activated", {
  //   //   category: "browse",
  //   //   bookshelf: appState.shelfCode,
  //   //   genre: Array.isArray(label) ? label.join(", ") : label,
  //   // });
  //   refine(refineValue);
  // };

  const handleDelete = (event: React.MouseEvent, refineValue: object, label: string) => {
    event.preventDefault();
    event.stopPropagation();
    // analytics.track("b filter attribute deactivated", {
    //   category: "browse",
    //   bookshelf: appState.shelfCode,
    //   genre: Array.isArray(label) ? label.join(", ") : label,
    // });
    refine(refineValue);
  };

  const values = items.map((item: any, i: number) => {
    if (item.isRefined || currentRefinement.indexOf(item.label) > -1) {
      return (
        <Chip
          key={`${item.label}-${i}`}
          label={`${item.label} (${item.count})`}
          aria-label={`Filter på ${item.label} - ${item.count} träffar. Klicka för att ta bort filter.`}
          onClick={(e) => handleDelete(e, item.value, item.label)}
          onDelete={(e) => handleDelete(e, item.value, item.label)}
          color="secondary"
          className={`${classes.chip} ${className}`}
          role="button"
        />
      );
    }
    // if (!onlyRefined) {
    //   return (
    //     <Chip
    //       key={`${item.label}-${i}`}
    //       label={`${item.label} (${item.count})`}
    //       onClick={(e) => handleClick(e, item.value, item.label)}
    //       color="primary"
    //       variant="outlined"
    //       className={`${classes.chip} ${classes.chipUnselected}`}
    //     />
    //   );
    // }
    return null;
  });

  if (virtual || values.length === 0) return null;

  return <Box display="inline-block">{values}</Box>;
};

export default connectRefinementList(RefinementListChips);
